import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppSettings } from '../../../app.settings';

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  emailUrl = `${AppSettings.EMAIL_API_ENDPOINT}/${'validateemail'}`;
  loginUrl = `${AppSettings.EMAIL_API_ENDPOINT}/${'elogin'}`;
  changePasswordUrl = `${AppSettings.EMAIL_API_ENDPOINT}/${'reset_password'}`;
  forgotPasswordUrl = `${AppSettings.EMAIL_API_ENDPOINT}/${'forgot_password'}`;
  sendOtp = `${AppSettings.EMAIL_API_ENDPOINT}/${'send_otp'}`;
  signUpVerifyOtp = `${AppSettings.EMAIL_API_ENDPOINT}/${'sign-up/verify-otp'}`;
  verifyOtp = `${AppSettings.EMAIL_API_ENDPOINT}/${'verify-2fa'}`;
  resetVerifyOtp = `${AppSettings.EMAIL_API_ENDPOINT}/${'reset/verify-otp'}`;

  userUrl = `${AppSettings.EMAIL_API_ENDPOINT}/${'loggedin_user'}`;
  companyLogoUrl = `${AppSettings.EMAIL_API_ENDPOINT}/${'company-logo'}`;
  loadCompanyLogo = `${AppSettings.EMAIL_API_ENDPOINT}/${'logo-image'}`;
  logOutUrl = `${AppSettings.EMAIL_API_ENDPOINT}/${'users/logout'}`;
  isAuthorizedUser: boolean = false;
  userDetails: any;
  enCryptKey: string = 'ABCDE1234!@#$';
  verifyToken: any;
  flowContext: {
    authMode: string;
    signupVerified?: boolean;
    passwordReset: boolean;
    email: string;
    directPasswordSetup?: boolean;
  } | null = null;
  constructor(private readonly http: HttpClient) {}

  getEmail(email: any) {
    return this.http.post(`${this.emailUrl}`, { email: email });
  }

  postEmail(data: any) {
    return this.http.post(this.loginUrl, data);
  }

  postPassword(data: any) {
    return this.http.post(this.changePasswordUrl, data);
  }

  forgotPasswordRest(email: string) {
    return this.http.post(`${this.forgotPasswordUrl}`, { email: email });
  }

  twoFactorLogin(email: string) {
    let payload = {
      email: email,
    };
    return this.http.post(`${this.sendOtp}`, payload);
  }

  signupVerifyOtpLogin(email: string, otp: string) {
    return this.http.post(`${this.signUpVerifyOtp}`, {
      email,
      verify_otp: otp,
    });
  }

  verifyOtpFlow(email: string, otp: string) {
    return this.http.post(`${this.verifyOtp}`, { email, otp });
  }

  resetVerifyOtpFlow(email: string, otp: string) {
    return this.http.post(`${this.resetVerifyOtp}`, { email, verify_otp: otp });
  }

  getUser() {
    return this.http.get(this.userUrl);
  }

  getCompanyLogo() {
    return this.http.get(this.companyLogoUrl);
  }

  loadLogoImage(profileName: string) {
    return this.http.get(`${this.loadCompanyLogo}/${profileName}`, {
      responseType: 'blob',
    });
  }

  getUserDetails() {
    return this.userDetails;
  }

  logout(user_id: any) {
    return this.http.post(this.logOutUrl, {});
  }
}
